import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";

export const WEBSERVICE = "https://institutional-bo.paybito.com:8443/BrokerAdminApi";


/*** function defination for showing toast ***/
export const showToast = (type, message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    showCloseButton: true,
    didOpen: (toast) => {
      const maxZ = Math.max(
        ...Array.from(
          document.querySelectorAll("body *"),
          (el) => parseFloat(window.getComputedStyle(el).zIndex) || 0
        )
      );
      toast.style.zIndex = maxZ + 10;
    },
    customClass: {
      popup: "custom-toast-width",
    },
  });

  Toast.fire({
    icon: type,
    title: message,
  });
};

/*** function defination for confirm message  ***/
export const swalAlert = (text, type) => {
  Swal.fire({
    // title: title,
    text: text,
    icon: type,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Ok",
  });

};

/*** function definition for guided flow wizard prompts ***/
export const showNextStepPrompt = (currentStep, navigate, customSuccessMsg) => {
  let text = '';
  let confirmButtonText = '';
  let nextRoute = '';

  if (currentStep === 'campaign') {
    text = `${customSuccessMsg || 'Campaign created successfully!'} Would you like to create or manage Audiences next?`;
    confirmButtonText = 'Yes, go to Audiences';
    nextRoute = '/create-audience';
  } else if (currentStep === 'audience') {
    text = `${customSuccessMsg || 'Audience created successfully!'} Would you like to create or manage Spend Caps next?`;
    confirmButtonText = 'Yes, go to Spend Caps';
    nextRoute = '/spend-caps';
  } else if (currentStep === 'spend-cap') {
    text = `${customSuccessMsg || 'Spend cap created successfully!'} Would you like to publish your campaign next?`;
    confirmButtonText = 'Yes, go to Publish';
    nextRoute = '/publish-campaign';
  } else {
    return;
  }

  Swal.fire({
    title: 'Success!',
    text: text,
    icon: 'success',
    showCancelButton: true,
    confirmButtonText: confirmButtonText,
    cancelButtonText: 'No, stay here',
    background: '#23272f',
    color: '#fff',
    confirmButtonColor: '#3b82f6',
    cancelButtonColor: '#4b5563',
  }).then((result) => {
    if (result.isConfirmed) {
      navigate(nextRoute);
    }
  });
};